<template>
  <div class="backdrop">
    <slot> </slot>
  </div>
</template>

<script setup lang="ts">
onBeforeMount(() => {
  document.body.classList.add("backdrop-open");
});

onBeforeUnmount(() => {
  document.body.classList.remove("backdrop-open");
});
</script>

<style lang="scss">
.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.65);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

body.backdrop-open {
  width: 100%;
  height: 100vh;
  transition: filter 2s;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
